import * as types from './ActionTypes';

export const setDialogVisibility = (data) => dispatch => {
  dispatch({
    type: types.SET_DIALOG_VISIBILITY,
    payload: {
      data: data.data,
      visibility: data.visibility
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/dialog.action.js